export default {
    initscript: initscript,
  };

function initscript() {
    removeEventListeners();

    stickyContainer = document.getElementById("sticky-container");
    if(!stickyContainer) {
        return;
    }

    mainBody = document.getElementById("mainBody");
    stickyElements = stickyContainer.querySelector("#sticky-elements");
    if(!mainBody || !stickyElements) {
        return;
    }

    fullbreddSida = stickyContainer.getAttribute("data-fullbredd-sida") == "true";
    breakpoint = parseInt(getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-xl'));
    nrRemFromTop = parseInt(getComputedStyle(stickyElements).getPropertyValue('--distFromTop'));
    stickyContainer.classList.value = stickyContainerClasses.Desktop;

    isDesktopView ? setDesktopView() : setMobileView();
    handelResize();
    addEventListeners();
}

const stickyContainerClasses = {
    Desktop: "desktop position-absolute z-3 d-flex d-print-none",
    DesktopWidePage: "desktop position-absolute z-3 d-flex end-0 d-print-none",
    Mobile: "mobile contentmax mx-lg-auto w-100 h-auto",
};
const stickyElementsClasses = {
    Mobile: "mobile",
    Top: "top position-absolute" ,
    Middle: "middle position-fixed",
    Bottom: "bottom position-absolute",
};

/**
 * @type {HTMLElement}
 */
var mainBody = undefined;
/**
 * @type {HTMLElement}
 */
var stickyContainer = undefined;
/**
 * @type {HTMLElement}
 */
var stickyElements = undefined;

var nrRemFromTop = 0;
var breakpoint = 0;
var isDesktopView = true;
var fullbreddSida = false;

var resizeObserver = undefined;
var resizeObserverMainBody = undefined;
var resizeObserverStickyElements = undefined;
var scrollObserverFunction = undefined;

function handelResize() {
    if(isDesktopView != window.innerWidth >= breakpoint) {
        if(isDesktopView) {
            setMobileView();
        } else {
            setDesktopView();
        }
    }

    if(isDesktopView) {
        updateStickyContainerHeight()
        handelScroll();
    }
}

function setDesktopView() {
    if(fullbreddSida) {
        stickyContainer.classList.value = stickyContainerClasses.DesktopWidePage;
    } else {
        stickyContainer.classList.value = stickyContainerClasses.Desktop;
    }
    isDesktopView = true;
}

function setMobileView() {
    stickyContainer.classList.value = stickyContainerClasses.Mobile;
    stickyElements.classList.value = stickyElementsClasses.Mobile;
    isDesktopView = false;
}

function handelScroll() {
    if(isDesktopView) {
        updatePlacementOfStickyElements();
    }
}

function updateStickyContainerHeight() {
    var containerTop = stickyContainer.getBoundingClientRect().top;
    var containerBottom = mainBody.getBoundingClientRect().bottom;
    stickyContainer.style.height = `${containerBottom-containerTop}px`;
}

function updatePlacementOfStickyElements() {
    var remToPxMultiplier = parseFloat(getComputedStyle(document.documentElement).fontSize);
    let nrPxFromTop = nrRemFromTop * remToPxMultiplier;

    if(stickyContainer.getBoundingClientRect().top <= nrPxFromTop) {
        if(nrPxFromTop + stickyElements.getBoundingClientRect().height >= stickyContainer.getBoundingClientRect().bottom) {
            stickyElements.classList.value = stickyElementsClasses.Bottom;
        }
        else
        {
            stickyElements.classList.value = stickyElementsClasses.Middle;
        }
    }
    else
    {
        stickyElements.classList.value = stickyElementsClasses.Top;
    }
}

function addEventListeners() {
    resizeObserver = new ResizeObserver(() => handelResize());
    resizeObserverMainBody = mainBody;
    resizeObserverStickyElements = stickyElements;
    resizeObserver.observe(resizeObserverMainBody);
    resizeObserver.observe(resizeObserverStickyElements);
    scrollObserverFunction = () => handelScroll();
    window.addEventListener('scroll', scrollObserverFunction);
}

function removeEventListeners() {
    if(resizeObserver) {
        if(resizeObserverMainBody) {
            resizeObserver.unobserve(resizeObserverMainBody);
        }
        if(resizeObserverStickyElements) {
            resizeObserver.unobserve(resizeObserverStickyElements);
        }
        resizeObserver.disconnect();
    }
    if(scrollObserverFunction) {
        window.removeEventListener('scroll', scrollObserverFunction);
    }
}